<template>
<div>
    <Partials message="Error en el servidor"/>
</div>
</template>

<script>
import Partials from '@/views/student/constants/errors/partials/button.vue'

export default {
    components: {
    Partials,
  },
}
</script>